import { RouteRecordRaw } from 'vue-router';
import AdminSignin from '@/components/pages/auth/AdminSignin.vue';
import LoginEmailConfirm from '@/components/pages/auth/LoginEmailConfirm.vue';
import SalesforceCallback from '@/components/pages/auth/SalesforceCallback.vue';
import SisenseSSOHandler from '@/components/pages/auth/SisenseSSOHandler.vue';
import UserResetPassword from '@/components/pages/auth/UserResetPassword.vue';
import UserSenderEmailConfirm from '@/components/pages/auth/UserSenderEmailConfirm.vue';
import UserSignin from '@/components/pages/auth/UserSignin.vue';
import VaAppLoginEmailConfirm from '@/components/pages/auth/VaAppLoginEmailConfirm.vue';
import VaAppResetPassword from '@/components/pages/auth/VaAppResetPassword.vue';
import VaAppSignin from '@/components/pages/auth/VaAppSignin.vue';
import VaAppZoomCallback from '@/components/pages/auth/VaAppZoomCallback.vue';
import ZoomCallback from '@/components/pages/auth/ZoomCallback.vue';
import Error from '@/components/pages/Error.vue';
import { i18nGlobal as i18n } from '@/i18n';

export const authRoutes: RouteRecordRaw[] =  [
  {
    path: '/admin/login',
    name: 'AdminSignin',
    component: AdminSignin,
    meta: {
      rule: 'all',
    },
  },
  {
    path: '/app/login',
    name: 'UserSignin',
    component: UserSignin,
    meta: {
      rule: 'all',
      title: i18n.t('auth.title'),
    },
  },
  {
    path: '/app/reset-password',
    name: 'UserResetPassword',
    component: UserResetPassword,
    meta: {
      rule: 'all',
    },
  },
  {
    path: '/app/sender-email/confirm/:token',
    name: 'UserSenderEmailConfirm',
    component: UserSenderEmailConfirm,
    meta: {
      rule: 'all',
    },
  },
  {
    path: '/app/login-email/confirm/:token',
    name: 'LoginEmailConfirm',
    component: LoginEmailConfirm,
    meta: {
      rule: 'all',
    },
  },
  {
    path: '/app/salesforce/oauth2/callback',
    name: 'SalesforceCallback',
    component: SalesforceCallback,
    meta: {
      rule: 'all',
    },
  },
  {
    path: '/app/zoom/oauth/callback',
    name: 'ZoomCallback',
    component: ZoomCallback,
    meta: {
      //TODO: zoom app の審査が完了したらruleをisCrmUserに変更する
      rule: 'all',
    },
  },
  {
    path: '/va-app/zoom/oauth/callback',
    name: 'VaAppZoomCallback',
    component: VaAppZoomCallback,
    meta: {
      rule: 'isVaUser',
    },
  },
  {
    path: '/app/sisense/sso/handler',
    name: 'SisenseSSOHandler',
    component: SisenseSSOHandler,
    meta: {
      rule: 'all',
    },
  },
  {
    path: '/va-app/login-email/confirm/:token',
    name: 'VaAppLoginEmailConfirm',
    component: VaAppLoginEmailConfirm,
    meta: {
      rule: 'all',
    },
  },
  {
    path: '/va-app/login',
    name: 'VaAppSignin',
    component: VaAppSignin,
    meta: {
      rule: 'all',
      title: i18n.t('auth.title'),
    },
  },
  {
    path: '/va-app/reset-password',
    name: 'VaAppResetPassword',
    component: VaAppResetPassword,
    meta: {
      rule: 'all',
    },
  },
  {
    path: '/error',
    name: 'Error',
    component: Error,
    meta: {
      rule: 'all',
    },
  },
];
